import { toast } from "sonner";
import { baseApi } from "../api/baseApi";
import msBaseApi from "../api/msBaseApi";
import {
  CompleteNextActionRequest,
  NextAction,
  TeamList,
  UpdateNextActionRequest,
} from "../types/nextAction.types";

// Re-export types
export type {
  CompleteNextActionRequest,
  NextAction,
  Team,
  TeamList,
  UpdateNextActionRequest,
} from "../types/nextAction.types";
// Define API service
export const nextActionApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getNextAction: builder.query<NextAction, number>({
      query: (customerNo) => ({
        url: `/v1/customer/next-action/${customerNo}`,
        method: "GET",
      }),
      providesTags: ["NextAction"],
    }),

    getTeams: builder.query<TeamList, void>({
      query: () => ({
        url: `/v1/customer/next-action/teams`,
        method: "GET",
      }),
      providesTags: ["Teams"],
    }),

    updateNextAction: builder.mutation<
      NextAction,
      { customerNo: number; request: UpdateNextActionRequest }
    >({
      query: ({ customerNo, request }) => ({
        url: `/v1/customer/next-action/${customerNo}`,
        method: "POST",
        body: request,
      }),
      async onQueryStarted({ request }, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;
          if (request.workItemNo) {
            toast.success("Aktivitet uppdaterad.");
            dispatch(msBaseApi.util.invalidateTags(["Calendar"]));
          } else {
            toast.success("Aktivitet skapad.");
          }
        } catch {
          toast.error("Det gick inte hantera förfrågan, testa igen senare.");
        }
      },

      invalidatesTags: [
        "NextAction",
        "MyCustomer",
        "WorkItem",
        "ProspectSuspectList",
        "Workitems",
        "Work",
      ],
    }),

    completeNextAction: builder.mutation<
      void,
      { customerNo: number; res: CompleteNextActionRequest }
    >({
      query: ({ customerNo, res }) => ({
        url: `/v1/customer/next-action/${customerNo}`,
        method: "DELETE",
        body: res,
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;

          toast.success("Aktivitet slutförd.");
        } catch {
          toast.error(
            "Det gick inte slutföra aktiviteten, försök igen senare."
          );
        }
      },
      invalidatesTags: (result, error, { res }) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const tags: any = [
          "NextAction",
          "MyCustomer",
          "Workitems",
          "Work",
          "ProspectSuspectList",
        ];
        if (res.WorkItemNo) {
          tags.push({ type: "WorkItem", id: res.WorkItemNo });
        }
        return tags;
      },
    }),
  }),
});

// Export hooks for usage in function components
export const {
  useGetNextActionQuery,
  useGetTeamsQuery,
  useUpdateNextActionMutation,
  useCompleteNextActionMutation,
} = nextActionApi;
